import {serializable, alias, primitive, object} from 'serializr';
import {ContentLibraryModel} from "../../ContentLibraryModel/contentLibrary.model";

export class ChapterContentModel{
    @serializable(alias('id', primitive()))
    id?: string;
    @serializable(alias('title', primitive()))
    displayTitle?: string;
    @serializable(alias('description', primitive()))
    displayDescription?: string;
    @serializable(alias('is_active', primitive()))
    isActive?: boolean;
    @serializable(alias('content_library', object(ContentLibraryModel)))
    contentLibrary?: string;
}
